// src/utils/dict.js
import { getItemsByType } from '@/api/system/dict'

// 全局字典缓存
const dictCache = new Map()

const dictUtil = {
  /**
   * 获取字典数据（支持缓存）
   */
  async getDict(typeCode) {
    if (dictCache.has(typeCode)) {
      return dictCache.get(typeCode)
    }

    try {
      const { data } = await getItemsByType(typeCode)
      dictCache.set(typeCode, data)
      return data
    } catch (error) {
      console.error(`获取字典 ${typeCode} 失败:`, error)
      return []
    }
  },

  /**
   * 批量获取字典
   */
  async getDicts(typeCodes) {
    const promises = typeCodes.map(code => this.getDict(code))
    return Promise.all(promises)
  },

  /**
   * 获取字典标签（智能处理同步/异步）
   */
  getLabel(typeCode, value, defaultLabel = '') {
    if (!typeCode || value == null) return defaultLabel
    // 如果已经有缓存，同步返回
    if (dictCache.has(typeCode)) {
      const dictData = dictCache.get(typeCode)
      const item = dictData.find(item => item.value == value)
      return item ? item.label : (defaultLabel || value)
    }
    
    // 如果没有缓存，返回一个占位符，并异步更新
    console.warn(`字典 ${typeCode} 未缓存，返回默认值`)
    return defaultLabel || value
  },

  /**
   * 异步获取字典标签
   */
  async getLabelAsync(typeCode, value, defaultLabel = '') {
    if (!typeCode || value == null) return defaultLabel
    
    try {
      const dictData = await this.getDict(typeCode)
      const item = dictData.find(item => item.value == value)
      return item ? item.label : (defaultLabel || value)
    } catch (error) {
      console.error(`获取字典标签失败 [${typeCode}:${value}]:`, error)
      return defaultLabel || value
    }
  },

  /**
   * 清除缓存
   */
  clearCache(typeCode = null) {
    if (typeCode) {
      dictCache.delete(typeCode)
    } else {
      dictCache.clear()
    }
  },

  /**
   * 手动设置缓存（可选）
   */
  setCache(typeCode, data) {
    dictCache.set(typeCode, data)
  }
}

// 作为插件安装
dictUtil.install = function(Vue) {
  Vue.prototype.$dict = dictUtil
}

export default dictUtil